import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { Link } from 'react-router-dom';

const Back = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const buttonStyle = {
        position: 'fixed',
        bottom: '50px',
        right: '50px',
        width: '46.34px',
        height: '46.34px',
        fontSize: '1.4rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#231B27',
        color: '#FFFFFF',
        border: '1px solid #231B27',
        borderRadius: '.4rem',
        cursor: 'pointer',
        zIndex: '1000',
    };

    return (
        <div className="scroll-to-top">
            {isVisible && (
                <Link to='/series' title='Back to series' style={buttonStyle}>
                    <IoIosArrowBack />
                </Link>
            )}
        </div>
    );
};


export default Back;
